import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted } from 'vue';
  import { useRoute } from 'vue-router';
  import { TaxonListStore } from '@/stores';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const route = useRoute();
  const taxonListStore = TaxonListStore.create<TaxonListStore>();

  onMounted(() => {
    taxonListStore.fetchData({ per_page: 50 });
  });


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view, {
    key: _unref(route).fullPath,
    "taxon-list-store": _unref(taxonListStore)
  }, null, 8, ["taxon-list-store"]))
}
}

})